var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-text",on:{"click":_vm.openTo}},[_c('span',[_vm._v(_vm._s(_vm.getUrl || '-'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }